import apiClient from 'lib/apiClient';

export const getPhoneType = (number) =>
  apiClient.get('API/1_0/getPhoneType.php', {
    params: {
      number,
    },
  });

export const getSIPUsers = () =>
  apiClient.get('API/1_0/sipUsers.php', {
    params: { load_connection: 1, load_caller: 1 },
  });

export const getSIPUser = (hash) =>
  apiClient
    .get('API/1_0/sipUsers.php', {
      params: { hash, load_connection: 1, load_caller: 1 },
    })
    .then((r) => r[0]);

export const saveSIPUser = (data) =>
  apiClient.post('API/1_0/sipUsers.php', data);

export const deleteSIPUser = (hash) =>
  apiClient.delete('API/1_0/sipUsers.php', {
    params: {
      hash,
    },
  });

export const testSIP = (data) =>
  apiClient.post('API/1_0/postSipTest.php', data);
